export const downloadFile = (response, type, fileName, fileType) => {
  // Create a Blob from the response data
  const pdfBlob = new Blob([response], { type: type });

  // Create a temporary URL for the Blob
  const url = window.URL.createObjectURL(pdfBlob);
  // Create a temporary <a> element to trigger the download
  const tempLink = document.createElement("a");
  tempLink.href = url;
  tempLink.download = `${fileName}.${fileType}`;
  tempLink.click();
  window.URL.revokeObjectURL(url);
  // tempLink.href = url;
  // tempLink.setAttribute("download", `${fileName}.${fileType}`); // Set the desired filename for the downloaded file
  // Append the <a> element to the body and click it to trigger the download
  // document.body.appendChild(tempLink);
  tempLink.click();
  // document.body.removeChild(tempLink);
  window.URL.revokeObjectURL(url);
};
